module.exports = __webpack_public_path__ + "static/media/headshot_alexis.a937e239.png";